// extracted by mini-css-extract-plugin
export default {"tupacGrid":"ul-z","tupacHeader":"vl-z","tupacHeader2":"wl-z","tupacMenu":"xl-z","tupacMenu2":"yl-z","tupacMain":"zl-z","tupacMain2":"Al-z"};